import * as doctor from './doctor.ts';

export { doctor };
